module.exports = __webpack_public_path__ + "static/img/EK.00768af6.png";